import React, { PropsWithChildren, useEffect } from "react";
import { useLocation } from "react-router";
import { UserProfileDialog } from "views/foundation/user/dialogs/UserProfileDialog";

type UserProfileProps = {
    userId: string | null;
    onBeforeLinkClick?: () => void;
};

export type UserProfileContextType = {
    showUser: (value: string | null, onBeforeLinkClick?: () => void) => void;
};

export const ModalUserProfileContext = React.createContext<UserProfileContextType>(null!);

export const useModalUserProfile = () => React.useContext(ModalUserProfileContext);

/**
 * Fornece um contexto de Sessão
 * @param param0
 */
export const ModalUserProfileProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [user, setUser] = React.useState<UserProfileProps | null>(null);
    const location = useLocation();

    useEffect(() => {
        setUser(null);
    }, [location.pathname]);

    return (
        <ModalUserProfileContext.Provider
            value={
                {
                    showUser: (userId, onBeforeLinkClick) => setUser({ userId, onBeforeLinkClick })
                }
            }
        >
            <UserProfileDialog
                userId={user?.userId ?? null}
                onBeforeLinkClick={user?.onBeforeLinkClick}
                onClose={() => setUser(null)}
            />

            {children}
        </ModalUserProfileContext.Provider>
    );
};
